import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import React from "react"

import { useTranslation } from "../../../../i18n/translate"
import { GalleryZoomPictureItem } from "../../model/gallery-item"
import "./zoom-image-preview.sass"

const ZoomImagePreview = ({ galleryPicture }) => {
  const { t } = useTranslation()
  return (
    <div className="_fp-image-preview">
      <div className="_fp-image-preview__thumbnail">
        {galleryPicture.useGatsbyImage() ? (
          <GatsbyImage image={galleryPicture.gatsbyFluidImage} />
        ) : (
          <img
            src={galleryPicture.thumbnailSrc}
            alt={t(galleryPicture.descriptionTranslationKey)}
          />
        )}
      </div>
    </div>
  )
}

ZoomImagePreview.propTypes = {
  galleryPicture: PropTypes.instanceOf(GalleryZoomPictureItem).isRequired,
}

export default ZoomImagePreview
